import { Subscribe } from "../../../../src/components/nats/Nats";
import * as React from 'react';
export default {
  Subscribe,
  React
};